<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Features"
    local-storage-key="features"
    :state="features"
    :read="featuresStore.readFeatures"
    :set="featuresStore.setFeatures"
    :delete="featuresStore.deleteFeature"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <FeatureForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {Feature} from '@/stores/userManagement/userManagement';

const featuresStore = useFeaturesStore();
const {features} = storeToRefs(featuresStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof Feature}>({
  'Feature Name': 'name',
  'Feature Description': 'description',
});
</script>
